import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-w-small', 'LetterWSmall', [["path",{"d":"M9 8l1 8l2 -5l2 5l1 -8"}]]);